export type LogSignupEventType = 'SignupPageViewed' | 'SignupPageConfirmed';

export const SIGNUP_PAGE_VIEWED = 'SignupPageViewed';
export const SIGNUP_PAGE_CONFIRMED = 'SignupPageConfirmed';
